// Icons
import { Box, BoxProps } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Editor } from '@tiptap/react';

import {
  Bold,
  HyperLink,
  Italics,
  OrderedList,
  StrikeThrough,
  Underline,
  UnorderedList,
} from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';

const MenuButton = styled(Button)`
  width: 28px;
  height: 28px;
  margin-right: 4px;
  svg {
    color: ${({ theme }) => theme.colors.text.g3};
  }
  &.is-active {
    svg {
      color: ${({ theme }) => theme.colors.text.g2};
    }
    background: ${({ theme }) => theme.colors.neutral.CFD7DF};
  }
  &:hover:enabled {
    svg {
      color: ${({ theme }) => theme.colors.text.g2};
    }
    background: ${({ theme }) => theme.colors.neutral.EBEFF3};
  }
`;

type RTE2MenuBarProps = {
  editor: Editor;
  toggleLinkModal: () => void;
  isLinkModalOpen: boolean;
  menuContainerProps?: BoxProps;
};

const RTE2MenuBar = ({ editor, toggleLinkModal, isLinkModalOpen, menuContainerProps }: RTE2MenuBarProps) => {
  if (!editor) {
    return null;
  }

  return (
    <Box mt="0px !important" className="editor-toolbar" {...menuContainerProps}>
      <MenuButton
        title="Bold"
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={`${editor.isActive('bold') ? 'is-active' : ''}`}
        StartIcon={Bold}
        variant="tertiary"
      />
      <MenuButton
        title="Italic"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={`${editor.isActive('italic') ? 'is-active' : ''}`}
        StartIcon={Italics}
        variant="tertiary"
      />
      <MenuButton
        title="Underline"
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={`${editor.isActive('underline') ? 'is-active' : ''}`}
        StartIcon={Underline}
        variant="tertiary"
      />
      <MenuButton
        title="Strikethrough"
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={!editor.can().chain().focus().toggleStrike().run()}
        className={`${editor.isActive('strike') ? 'is-active' : ''}`}
        StartIcon={StrikeThrough}
        variant="tertiary"
      />
      <div className="toolbar-divider" />
      <MenuButton
        title="Bullet List"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`${editor.isActive('bulletList') ? 'is-active' : ''}`}
        StartIcon={UnorderedList}
        variant="tertiary"
      />
      <MenuButton
        title="Numbered List"
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={` ${editor.isActive('orderedList') ? 'is-active' : ''}`}
        StartIcon={OrderedList}
        variant="tertiary"
      />
      <div className="toolbar-divider" />
      <MenuButton
        title="Link"
        onClick={toggleLinkModal}
        disabled={
          !editor
            .can()
            .chain()
            .extendMarkRange('link')
            .toggleLink({
              href: null,
            })
            .run()
        }
        className={`${editor.isActive('link') || isLinkModalOpen ? 'is-active' : ''}`}
        StartIcon={HyperLink}
        variant="tertiary"
      />
    </Box>
  );
};

export { RTE2MenuBar };
